<template>
  <div class="device-detail-sheet-daily-sbr">
    <div class="box">
      <div class="title">
        <i class="icon icon-tishi"></i>
        {{ dayTips }}
      </div>
      <div class="usage">
        <div class="usage-introduction">
          <div class="introduction-right">
            <template v-for="func in deviceInfo.supportFunc.split(',')">
              <div class="manual" v-if="func === 'manual'" :key="func">
                  <i></i>
                {{ iot_tsl_use_type2['2'] }}
              </div>
              <div class="auto" v-else-if="func === 'autonomous'" :key="func">
                <i></i>
                {{ iot_tsl_use_type2['5'] }}
              </div>
              <div class="train" v-else-if="func === 'training'" :key="func">
                <i></i>
                {{ iot_tsl_use_type2['4'] }}
              </div>
              <div class="charge"  v-else-if="func === 'charging'" :key="func">
                <i></i>
                {{ iot_tsl_use_type2['1'] }}
              </div>
              <div class="boot" v-else-if="func === 'boot'" :key="func">
                <i></i>
                {{ iot_tsl_use_type2['8'] }}
              </div>
            </template>
          </div>
        </div>
        <div class="usage-hours">
          <div class="usage-icon">
            <i>
              <img src="~@/images/layout/icon_day.png" alt />
            </i>
            <i>
              <img src="~@/images/layout/icon_night.png" alt />
            </i>
          </div>
          <ul class="log">
            <li class="line">
              <div class="bg">
                <template v-for="(item, index) in line1">
                  <template v-if="item.workTime">
                    <el-popover placement="top-start" trigger="hover" :key="index">
                      <div
                        slot="reference"
                        :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4', boot: `${item.workClass}` === '8' }"
                        style="height: 12px; position: absolute"
                        :style="{ width: (item.p2 - item.p1) * 100 + '%', left: item.p1 * 100 + '%' }"
                      ></div>
                      <div class="popover-content">
                        <template>
                          <!-- <p v-if="`${item.workClass}` === '4'">{{ $t('page_content_teaching_time }}:{{ item.usageTimeFormat }}</p>
                          <p v-else>{{ $t('page_content_running_time_unit }}:{{ item.usageTimeFormat }}</p> -->
                          <p v-if="item.workTime&&`${item.workClass}` === '1'">{{ $t('dms_device_detail_sheet_day.cdschm') }}: {{ $formatSecToHm(item.workTime) }}</p>
                        <p v-if="item.workTime&&`${item.workClass}`!== '1'">{{`${iot_tsl_use_type2[item.workClass]}`}}{{ $t('dms_device_detail_sheet_day.shi_changhm') }}: {{ $formatSecToHm(item.workTime) }}</p>
                        </template>
                      </div>
                    </el-popover>
                  </template>
                  <template v-else>
                    <div
                      :key="index"
                      :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4', boot: `${item.workClass}` === '8' }"
                      style="height: 12px; position: absolute"
                      :style="{
                        width: (item.p2 - item.p1) * 100 + '%',
                        left: item.p1 * 100 + '%',
                      }"
                    ></div>
                  </template>
                </template>
              </div>
              <div class="lable-box">
                <!-- <i v-for="item in 7" :key="item">{{ item + 5 }}</i> -->
                <i v-for="item in line1Lable" :key="item">{{ item }}</i>
              </div>
            </li>
            <li class="line">
              <div class="bg">
                <template v-for="(item, index) in line2">
                  <template v-if="item.workTime">
                    <el-popover placement="top-start" trigger="hover" :key="index">
                      <div
                        slot="reference"
                        :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4', boot: `${item.workClass}` === '8' }"
                        style="height: 12px; position: absolute"
                        :style="{ width: (item.p2 - item.p1) * 100 + '%', left: item.p1 * 100 + '%' }"
                      ></div>
                      <div class="popover-content">
                        <template>
                          <!-- <p v-if="`${item.workClass}` === '4'">{{ $t('page_content_teaching_time }}:{{ item.usageTimeFormat }}</p>
                          <p v-else>{{ $t('page_content_running_time_unit }}:{{ item.usageTimeFormat }}</p> -->
                          <p v-if="item.workTime&&`${item.workClass}` === '1'">{{ $t('dms_device_detail_sheet_day.cdschm') }}: {{ $formatSecToHm(item.workTime) }}</p>
                          <p v-if="item.workTime&&`${item.workClass}`!== '1'">{{`${iot_tsl_use_type2[item.workClass]}`}}{{ $t('dms_device_detail_sheet_day.shi_changhm') }}: {{ $formatSecToHm(item.workTime) }}</p>
                        </template>
                      </div>
                    </el-popover>
                  </template>
                  <template v-else>
                    <div
                      :key="index"
                      :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4', boot: `${item.workClass}` === '8' }"
                      style="height: 12px; position: absolute"
                      :style="{
                        width: (item.p2 - item.p1) * 100 + '%',
                        left: item.p1 * 100 + '%',
                      }"
                    ></div>
                  </template>
                </template>
              </div>
              <div class="lable-box">
                <!-- <i v-for="item in 7" :key="item">{{ item + 11 }}</i> -->
                <i v-for="item in line2Lable" :key="item">{{ item }}</i>
              </div>
            </li>
            <li class="line">
              <div class="bg">
                <template v-for="(item, index) in line3">
                  <template v-if="item.workTime">
                    <el-popover placement="top-start" trigger="hover" :key="index">
                      <div
                        slot="reference"
                        :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4',boot: `${item.workClass}` === '8' }"
                        style="height: 12px; position: absolute"
                        :style="{ width: (item.p2 - item.p1) * 100 + '%', left: item.p1 * 100 + '%' }"
                      ></div>
                      <div class="popover-content">
                        <template>
                          <!-- <p v-if="`${item.workClass}` === '4'">{{ $t('page_content_teaching_time }}:{{ item.usageTimeFormat }}</p>
                          <p v-else>{{ $t('page_content_running_time_unit }}:{{ item.usageTimeFormat }}</p> -->
                          <p v-if="item.workTime&&`${item.workClass}` === '1'">{{ $t('dms_device_detail_sheet_day.cdschm') }}: {{ $formatSecToHm(item.workTime) }}</p>
                          <p v-if="item.workTime&&`${item.workClass}`!== '1'">{{`${iot_tsl_use_type2[item.workClass]}`}}{{ $t('dms_device_detail_sheet_day.shi_changhm') }}: {{ $formatSecToHm(item.workTime) }}</p>
                        </template>
                      </div>
                    </el-popover>
                  </template>
                  <template v-else>
                    <div
                      :key="index"
                      :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4',boot: `${item.workClass}` === '8' }"
                      style="height: 12px; position: absolute"
                      :style="{
                        width: (item.p2 - item.p1) * 100 + '%',
                        left: item.p1 * 100 + '%',
                      }"
                    ></div>
                  </template>
                </template>
              </div>
              <div class="lable-box">
                <!-- <i v-for="item in 7" :key="item">{{
                item + 17 > 24 ? item + 17 - 24 : item + 17
              }}</i> -->
                <i v-for="item in line3Lable" :key="item">{{ item }}</i>
              </div>
            </li>
            <li class="line">
              <div class="bg">
                <template v-for="(item, index) in line4">
                  <template v-if="item.workTime">
                    <el-popover placement="top-start" trigger="hover" :key="index">
                      <div
                        slot="reference"
                        :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4',boot: `${item.workClass}` === '8' }"
                        style="height: 12px; position: absolute"
                        :style="{ width: (item.p2 - item.p1) * 100 + '%', left: item.p1 * 100 + '%' }"
                      ></div>
                      <div class="popover-content" v-if="item.workTime">
                        <template>
                          <!-- <p v-if="`${item.workClass}` === '4'">{{ $t('page_content_teaching_time') }}:{{ item.usageTimeFormat }}</p>
                          <p v-else>{{`${iot_tsl_use_type2[item.workClass]}`}}{{ $t('page_content_running_time_unit') }}:{{ item.usageTimeFormat }}</p> -->
                          <p v-if="item.workTime&&`${item.workClass}` === '1'">{{ $t('dms_device_detail_sheet_day.cdschm') }}: {{ $formatSecToHm(item.workTime) }}</p>
                          <p v-if="item.workTime&&`${item.workClass}`!== '1'">{{`${iot_tsl_use_type2[item.workClass]}`}}{{ $t('dms_device_detail_sheet_day.shi_changhm') }}: {{ $formatSecToHm(item.workTime) }}</p>
                        </template>
                      </div>
                    </el-popover>
                  </template>
                  <template v-else>
                    <div
                      :key="index"
                      :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4',boot: `${item.workClass}` === '8' }"
                      style="height: 12px; position: absolute"
                      :style="{
                        width: (item.p2 - item.p1) * 100 + '%',
                        left: item.p1 * 100 + '%',
                      }"
                    ></div>
                  </template>
                </template>
              </div>
              <div class="lable-box">
                <!-- <i v-for="item in 7" :key="item">{{ item - 1 }}</i> -->
                <i v-for="item in line4Lable" :key="item">{{ item }}</i>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="sheet-info box">
      <ul class="box">
        <template v-for="func in deviceInfo.supportFunc.split(',')">
          <!-- 手工-->
          <template v-if="func === 'manual'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_day.ren_gong_qing_jie') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.qing_jie_shi_changhm')">
                    {{ $t('dms_device_detail_sheet_day.qing_jie_shi_changhm') }}
                  </h2>
                  <p>{{ info.manualUsageTime === 0 ? '-' : $formatSecToHm(info.manualUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.qing_jie_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_sheet_day.qing_jie_mian_ji') }}{{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.manualCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.manualCleanArea))| formatThousandth }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.qing_jie_ci_shu')">
                  {{ $t('dms_device_detail_sheet_day.qing_jie_ci_shu') }}
                  </h2>
                  <p>{{ info.manualUsageCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 智能清洁-->
          <template v-else-if="func === 'autonomous'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_day.zi_zhu_qing_jie') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.qing_jie_shi_changhm')">
                    {{ $t('dms_device_detail_sheet_day.qing_jie_shi_changhm') }}
                  </h2>
                  <p>{{ info.autonomousUsageTime === 0 ? '-' : $formatSecToHm(info.autonomousUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.qing_jie_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_sheet_day.qing_jie_mian_ji') }}{{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.autonomousCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.autonomousCleanArea))| formatThousandth }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.fu_zhu_ci_shu')">
                    {{ $t('dms_device_detail_sheet_day.fu_zhu_ci_shu') }}
                  </h2>
                  <p>{{ info.assistCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <template v-else-if="func === 'training'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_day.jiao_xue') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.jiao_xue_shi_changhm')">
                    {{ $t('dms_device_detail_sheet_day.jiao_xue_shi_changhm') }}
                  </h2>
                  <p>{{ info.trainingUsageTime === 0 ? '-' : $formatSecToHm(info.trainingUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.jiao_xue_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_sheet_day.jiao_xue_mian_ji') }}{{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.trainingCleanArea === 0 ? '-' : $toFixed(info.trainingCleanArea) }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 开机 -->
          <template  v-else-if="func === 'boot'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_day.kai_ji') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.kai_ji_shi_changhm')">
                    {{$t('dms_device_detail_sheet_day.kai_ji_shi_changhm')}}
                  </h2>
                  <p>{{ info.bootTime === 0 ? '-' : $formatSecToHm(info.bootTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.kai_ji_ci_shu')">
                    {{$t('dms_device_detail_sheet_day.kai_ji_ci_shu')}}
                  </h2>
                  <p>{{ info.bootCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 充电-->
          <template v-else-if="func === 'charging'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_day.chong_dian') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_day.cdschm')">
                    {{ $t('dms_device_detail_sheet_day.cdschm') }}
                  </h2>
                  <p>{{ info.chargingTime === 0 ? '-' : $formatSecToHm(info.chargingTime) }}</p>
                </li>
              </ul>
            </li>
          </template>
        </template>
      </ul>
    </div>
    <div class="detail-list box">
      <!-- 数据详情 -->
      <div class="path">
        <!-- <div class="head">
        <p class="titel">
          {{ $t('page_content_boot_card_use_details1 }}
        </p>
        <el-button type="primary" @click="exportDay"
          ><i class="icon icon-daochu"></i>
          {{ $t('com_export_data }}</el-button
        >
      </div> -->
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <!-- <el-form-item>
              <p class="titel">
                {{ $t('page_content_boot_card_use_details1 }}
              </p>
            </el-form-item> -->
            <el-form-item style="float: right; margin-right: 0">
              <!-- <custom-column :code="tableCode" v-model="tableColumn"></custom-column> -->
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <!-- 导出 -->
            <el-form-item style="float: right">
              <el-button class="table-set" style="vertical-align: top" @click="exportDay">
                <i class="icon icon-daochu"></i>
              </el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <switch-button :link="$refs.container"></switch-button>
            </el-form-item>
          </el-form>
        </div>
        <switch-container ref="container" @search="getSheetDayInfo()" @clear="clearFilter()">
          <el-form :inline="true" label-position="top">
            <el-form-item :label="$t('dms_device_detail_sheet_day.jie_shu_shi_jian')">
              <!-- 已修改时区 -->
              <el-time-picker is-range v-model="formSearch.timer" range-separator="——" start-placeholder="" value-format="yyyy-MM-dd HH:mm:ss" end-placeholder=""></el-time-picker>
            </el-form-item>
            <!-- 站点 -->
            <el-form-item :label="$t('dms_device_detail_sheet_day.zhan_dian')">
              <custom-select
                url="DeviceReportSiteSiteList"
                :props="{ label: 'siteName', value: 'siteCode' }"
                :auto="false"
                :listener="`${formSearch.bodyNum}${formSearch.startTime}${formSearch.endTime}`"
                :placeholder="$t('Common.com_please_select')"
                :params="{ ...formSearch }"
                v-model="formSearch.siteCode"
                :noBoder="true"
                width="100%"
              ></custom-select>
            </el-form-item>
            <!-- 定位码 -->
            <el-form-item :label="$t('dms_device_detail_sheet_day.ding_wei_ma')">
              <el-input v-model="formSearch.hlcCode" placeholder="" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item :label="$t('dms_device_detail_sheet_day.lu_xian_cao')">
              <el-input v-model="formSearch.slotCode" placeholder="" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item :label="$t('dms_device_detail_sheet_day.mo_shi')">
              <custom-select v-model="formSearch.workClass" code="iot_tsl_use_type2" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
            </el-form-item>
            <!-- 地图名称 -->
            <el-form-item :label="$t('dms_device_detail_sheet_day.di_tu_ming_cheng')">
              <el-input v-model="formSearch.mapName" placeholder="" style="width: 100%"></el-input>
            </el-form-item>
          </el-form>
        </switch-container>
        <div class="table-bd">
          <custom-table :data="dayList" :index="true" @filter="filterChange" @sort="sortChange"
            v-if="isInch"
            tableCode="device_sheet_day_ft"
            @column="setColumn"
           :slots="['runRoute', 'workClass','cleanedArea','runLength','startTime','endTime']">
            <template v-slot:cleanedArea="scope">
              <span>{{$formatLenLocal(scope.row.cleanedArea)| formatThousandth}}</span>
            </template>
            <template v-slot:runLength="scope">
              <span>{{$formatLenLocal(scope.row.runLength,true)}}</span>
            </template>
            <template slot="startTime" slot-scope="scope">
              {{ momentAmPm($transFormat(scope.row.startTime)) }}
            </template>
            <template slot="endTime" slot-scope="scope">
              {{ momentAmPm($transFormat(scope.row.endTime)) }}
            </template>
            <template slot="workClass" slot-scope="scope">
              {{ iot_tsl_use_type2[scope.row.workClass] }}
            </template>
            <template v-slot:runRoute="scope">
              <span
                v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
                style="cursor: pointer; color: #0d9ae0"
                @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
              >
                {{ $t('Common.com_detail') }}
              </span>
            </template>
          </custom-table>
          <custom-table :data="dayList" :index="true" @filter="filterChange" @sort="sortChange"
            v-else
            tableCode="device_sheet_day"
            @column="setColumn"
            :slots="['runRoute', 'workClass','startTime','endTime']"
          >
            <template slot="workClass" slot-scope="scope">
              {{ iot_tsl_use_type2[scope.row.workClass] }}
            </template>
            <template slot="startTime" slot-scope="scope">
              {{ momentAmPm($transFormat(scope.row.startTime)) }}
            </template>
            <template slot="endTime" slot-scope="scope">
              {{ momentAmPm($transFormat(scope.row.endTime)) }}
            </template>
            <template v-slot:runRoute="scope">
              <span
                v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
                style="cursor: pointer; color: #0d9ae0"
                @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
              >
                {{ $t('Common.com_detail') }}
              </span>
            </template>
          </custom-table>
        </div>
      </div>
      <!-- 查看地图图片 -->
      <el-image-viewer v-if="dialogVisibleImage" class="img"  :url-list="[dialogImageUrl]"  :on-close="()=>dialogVisibleImage=false" ></el-image-viewer>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';

export default {
  components: {},
  props: {
    deviceInfo: [Object, Array],
    startTime: [String, Number],
    endTime: [String, Number],

    isCharging: {
      type: Boolean,
      default: false,
    },
    isManual: {
      type: Boolean,
      default: false,
    },
    isAutonomous: {
      type: Boolean,
      default: false,
    },
    isTraining: {
      type: Boolean,
      default: false,
    },
    isBoot: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    dayTips() {
      return this.$t('dms_device_detail_sheet_day.bbyoodojqscdsjsc', [this.area,this.tipsDayStartTime,this.tipsDayEndTime]);
    },
    line1Lable() {
      const offset = Number(this.deviceInfo.localReportOffset) || 0;
      return Array.from({ length: 7 }, (_, i) => (offset + i) % 24);
    },
    line2Lable() {
      const offset = Number(this.deviceInfo.localReportOffset) || 0;
      return Array.from({ length: 7 }, (_, i) => (offset + 6 + i) % 24);
    },
    line3Lable() {
      const offset = Number(this.deviceInfo.localReportOffset) || 0;
      return Array.from({ length: 7 }, (_, i) => (offset + 12 + i) % 24);
    },
    line4Lable() {
      const offset = Number(this.deviceInfo.localReportOffset) || 0;
      return Array.from({ length: 7 }, (_, i) => {
        const hour = (offset + 18 + i) % 24;
        return hour === 0 ? 24 : hour;
      });
    },
  },
  data() {
    return {
      formSearch: {
        bodyNum: this.deviceInfo.bodyNum,
        startTime: '',
        endTime: '',
        // 筛选
        timer: '',
        searchStartTime: '', // 结束时间
        searchEndTime: '', // 结束时间
        siteCode: '', // 站点
        hlcCode: '', // 定位码
        slotCode: '', // 路径
        mapName: '', // 地图名称
        workClass: '', // 模式
      },
      dayList: [],
      // totalRows: null,
      info: {
        // ICE
        chargingTime: '', // 充电时长
        manualUsageTime: '', // 手工清洁时间
        manualCleanArea: '', // 手工清洁面积
        manualUsageCount: '', // 手工清洁次数
        lastDataUploadedTime: '', // 最后清洁时间
        // SBR
        // 手工清洁时长 h:m ,
        // 手工清洁面积 m²,
        autonomousUsageTime: '', // 智能清洁时长 h:m',
        autonomousCleanArea: '', // 智能清洁面积 m²',
        assistCount: '', // 辅助次数,
        trainingUsageTime: '', // 教学时长 h:m,
        trainingCleanArea: '', // 教学面积 m²,
        totalUsageCount: '', // 清洁次数,
        bootTime: '', // 开机时长 h:m,
        bootCount: '', // 开机次数,
      },
      scheduleList: [],

      line1: [],
      line2: [],
      line3: [],
      line4: [],

      dialogVisibleImage: false,
      dialogImageUrl: '',

      iot_tsl_use_type2: {},
      // 提示开始区间
      tipsDayStartTime: '',
      tipsDayEndTime: '',
      area: '',

      workClassList: [],
    };
  },
  watch: {
    startTime() {
      // this.formSearch.startTime = this.startTime;
      // this.formSearch.endTime = val = moment(val).format('YYYY-MM-DD');
      // this.formSearch.startTime = this.$momentWorld(moment(this.startTime));
      // this.formSearch.endTime = this.$momentWorld(moment(this.endTime));
      this.refreshPage();
      this.formSearch.timer = ''; // 发布时间
    },
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.refreshPage();
    this.getDictionary('iot_tsl_use_type2', (data) => {
      this.iot_tsl_use_type2 = this.$transformDicValue(data.iot_tsl_use_type2);
    });
  },
  methods: {
    // 获取今日详情
    getSheetInfo: function () {
      this.$getJSON(apis.DeviceReportDaily, {
        ...this.formSearch,
        startTime: '',
        endTime: '',
        reportDate: this.$momentElLocal(this.startTime, 'YYYY-MM-DD')
      }).then((res) => {
        if (res.data && Object.keys(res.data).length !== 0) {
          this.$setFormatData(this.info, res.data);
        } else {
          this.info.chargingTime = '';
          this.info.manualUsageTime = '';
          this.info.manualRunLength = '';
          this.info.manualCleanArea = '';
          this.info.manualUsageCount = '';
          this.info.autonomousUsageTime = '';
          this.info.autonomousRunLength = '';
          this.info.autonomousCleanArea = '';
          this.info.trainingUsageTime = '';
          this.info.trainingRunLength = '';
          this.info.trainingCleanArea = '';
          this.info.assistCount = '';
          this.info.totalUsageCount = '';
          this.info.bootTime = '';
          this.info.bootCount = '';
        }
      });
    },
    setUseTypeList: function () {
      // "1": "充电", "2": "清洁", "4": "教学", "5": "自动"
      this.workClassList = [];
      if (this.isCharging) {
        this.workClassList.push('1');
      }
      if (this.isManual) {
        this.workClassList.push('2');
      }
      if (this.isAutonomous) {
        this.workClassList.push('5');
      }
      if (this.isTraining) {
        this.workClassList.push('4');
      }
      if (this.isBoot) {
        this.workClassList.push('8');
      }
    },
    // 获取今日详情
    getSheetDayInfo: function () {
      let tipsDayStartTime;
      let tipsDayEndTime;
      const timer = this.formSearch.timer;
      // 获取未转utc前的日期（相当于endTime）
      const YYYYMMDD = moment(this.formSearch.endTime).format('YYYY-MM-DD');
      if (timer && timer[0]) {
        const startTimeStr = this.$momentWorld(`${YYYYMMDD} ${timer[0].split(' ')[1]}`);
        const endTimeStr = this.$momentWorld(`${YYYYMMDD} ${timer[1].split(' ')[1]}`);
        tipsDayStartTime = startTimeStr;
        tipsDayEndTime = endTimeStr;
      }
      this.formSearch.workClass = `${this.formSearch.workClass}`;
      const reqData = {
        ...this.formSearch,
        startTime: tipsDayStartTime || this.formSearch.startTime,
        endTime: tipsDayEndTime || this.formSearch.endTime,
        isTimeSearch: tipsDayEndTime ? 1 : 0,
        reportDate: this.$momentElLocal(this.startTime, 'YYYY-MM-DD')
      };

      this.$getJSON(apis.DeviceReportDailyWorkRunList, reqData).then((res) => {
        // this.dayList = res.data || [];
        const data = res.data || [];
        // 如果是充电模式
        data.forEach((i) => {
          if (i.workClass === '1') {
            i.siteName = '-';
            i.hlcCode = '-';
            i.slotCode = '-';
            i.cleanedArea = '-';
            i.usageTimeFormat = '-';
            i.runLength = '-';
            i.assistCount = '-';
          }
        });
        this.nullValueToCrossbar(data, ['assistCount']);
        this.setUseTypeList();
        const filterData = data.filter(item => this.workClassList.includes(`${item.workClass}`) && !!item.endTime);
        // 记录的世界时间转本地时间
        filterData.forEach((i) => {
          i.startTime = this.$momentElLocal(i.startTime);
          i.endTime = this.$momentElLocal(i.endTime);
        });
        this.dayList = filterData;

        // 1是ICe 2是sbr Whiz deviceInfo.productBrand==='ICE'"
        // "1": "充电", "2": "清洁", "4": "教学", "5": "自动"
        // this.scheduleList = this.dayList.filter(item => `${item.workClass}` === '1' || `${item.workClass}` === '2' || `${item.workClass}` === '4' || `${item.workClass}` === '5');
        this.scheduleList = this.dayList;
        this.scheduleList.forEach((item) => {
          item.progress = this.progressSet(item);
        });
        this.line1 = [];
        this.line2 = [];
        this.line3 = [];
        this.line4 = [];
        // 第一行  (6-12点 选第二段line=2)
        this.line1 = this.scheduleList
          .map((oldItem) => {
            let newItem = {};
            newItem = { ...oldItem };
            newItem.progress = null;
            const progress1 = oldItem.progress.filter(ptem => ptem.line === 1);
            progress1.forEach((pItem) => {
              newItem.line = pItem.line;
              newItem.p1 = pItem.p1;
              newItem.p2 = pItem.p2;
            });
            return newItem;
          })
          .filter(item => !!item.line);
        // 第二行  (12-18点 选第二段line=3)
        this.line2 = this.scheduleList
          .map((oldItem) => {
            let newItem = {};
            newItem = { ...oldItem };
            newItem.progress = null;
            const progress1 = oldItem.progress.filter(ptem => ptem.line === 2);
            progress1.forEach((pItem) => {
              newItem.line = pItem.line;
              newItem.p1 = pItem.p1;
              newItem.p2 = pItem.p2;
            });
            return newItem;
          })
          .filter(item => !!item.line);
        // 第三行  (18-24点 选第二段line=4)
        this.line3 = this.scheduleList
          .map((oldItem) => {
            let newItem = {};
            newItem = { ...oldItem };
            newItem.progress = null;
            const progress1 = oldItem.progress.filter(ptem => ptem.line === 3);
            progress1.forEach((pItem) => {
              newItem.line = pItem.line;
              newItem.p1 = pItem.p1;
              newItem.p2 = pItem.p2;
            });
            return newItem;
          })
          .filter(item => !!item.line);
        // 第四行  (0-6点 选第二段line=1)
        this.line4 = this.scheduleList
          .map((oldItem) => {
            let newItem = {};
            newItem = { ...oldItem };
            newItem.progress = null;
            const progress1 = oldItem.progress.filter(ptem => ptem.line === 4);
            progress1.forEach((pItem) => {
              newItem.line = pItem.line;
              newItem.p1 = pItem.p1;
              newItem.p2 = pItem.p2;
            });
            return newItem;
          })
          .filter(item => !!item.line);
      });
    },
    // 获取今日报表时间区间
    getDailyTime: function () {
      this.$getJSON(apis.DeviceReportDailyTime, {
        bodyNum: this.deviceInfo.bodyNum,
        date: this.$momentElLocal(this.startTime, 'YYYY-MM-DD'),
      }).then((res) => {
        this.tipsDayStartTime = res.data.startTime;
        this.tipsDayEndTime = res.data.endTime;
        this.area = res.data.hqTimeName;

        // this.formSearch.startTime = this.$momentWorld(res.data.startTime);
        // this.formSearch.endTime = this.$momentWorld(res.data.endTime);
        this.formSearch.startTime = res.data.reportStartTime;
        this.formSearch.endTime = res.data.reportEndTime;
        this.getSheetDayInfo();
        this.getSheetInfo();
      });
    },
    // 时间进度条长度
    progressSet: function (time) {
      const result = [];
      const allSeconds = 6 * 60 * 60 * 4;
      const offset = Number(this.deviceInfo.localReportOffset) || 0;
      // 保持原有传参方式，使用动态时间格式
      const startPoint = moment(this.$momentElLocal(this.startTime, 'YYYY-MM-DD 00:00:00'))
        .add(offset, 'hours') // 这里支持负数，会自动转换为减法
        .subtract(1, 'second')
        .unix();
      const p = {
        p1: (moment(time.startTime).unix() - startPoint) / allSeconds, // 开始点的百分数占四条线总长度的百分比
        p2: (moment(time.endTime).unix() - startPoint) / allSeconds, // 结束点的百分数占四条线总长度的百分比
      };
      // 出现跨天设置为一天后面都铺满
      if (p.p2 > 1) {
        p.p2 = 1;
      }
      // 如果开始事件超出
      if (p.p1 > 1) {
        return result;
      }
      const arr = [0, 0.25, 0.5, 0.75, 1];
      const lineIndexStart = arr.findIndex((item, index) => p.p1 > item && p.p1 <= arr[index + 1]) + 1;
      const lineIndexEnd = arr.findIndex((item, index) => p.p2 > item && p.p2 <= arr[index + 1]) + 1;
      const point = {
        x1: 0, // 开始点占当前线段的百分比
        x2: 0, // 结束点占当前线段的百分比
      };
      switch (lineIndexStart) {
        case 1:
          point.x1 = p.p1 / 0.25;
          break;
        case 2:
          point.x1 = (p.p1 - 0.25) / 0.25;
          break;
        case 3:
          point.x1 = (p.p1 - 0.5) / 0.25;
          break;
        case 4:
          point.x1 = (p.p1 - 0.75) / 0.25;
          break;
      }
      switch (lineIndexEnd) {
        case 1:
          point.x2 = p.p2 / 0.25;
          break;
        case 2:
          point.x2 = (p.p2 - 0.25) / 0.25;
          break;
        case 3:
          point.x2 = (p.p2 - 0.5) / 0.25;
          break;
        case 4:
          point.x2 = (p.p2 - 0.75) / 0.25;
          break;
      }

      // console.log('开始点在第' + lineIndexStart + '条线上')
      // console.log('结束点在第' + lineIndexEnd + '条线上')

      if (lineIndexStart === lineIndexEnd) {
        // 如果一直都是同一个状态
        result.push({
          line: lineIndexStart,
          p1: point.x1,
          p2: point.x2,
        });
      } else {
        result.push({
          line: lineIndexStart,
          p1: point.x1,
          p2: 1,
        });

        for (let index = lineIndexStart + 1; index < lineIndexEnd; index++) {
          result.push({
            line: index,
            p1: 0,
            p2: 1,
          });
        }

        result.push({
          line: lineIndexEnd,
          p1: 0,
          p2: point.x2,
        });
      }
      return result;
    },
    mapIdDetails(routeId, workClass) {
      // w是自主
      // t是教学
      let type = '';
      if (`${workClass}` === '5') {
        type = 'w';
      } else if (`${workClass}` === '4') {
        type = 't';
      }
      if (!routeId || !type) {
        return;
      }
      this.$getJSON(`${apis.OssAttach}/${routeId}/${type}`).then((res) => {
        const list = res.data || [];
        const url = this.getAttachUrl(list[0]);
        this.dialogImageUrl = url;
        this.dialogVisibleImage = true;
      });
    },
    // 查看地图
    // mapDetails(url) {
    //   this.dialogVisibleImage = true;
    //   this.dialogImageUrl = url;
    // },
    // 数据导出
    exportDay: function () {
      this.$exportFlie(apis.DeviceReportDailyWorkRunExport, { ...this.formSearch, reportDate: this.$momentElLocal(this.startTime, 'YYYY-MM-DD'), }).then(() => {});
    },
    // 刷新
    refreshPage: function () {
      this.getDailyTime();
    },
    clearFilter: function () {
      this.formSearch.siteCode = ''; // 站点
      this.formSearch.hlcCode = ''; // 定位码
      this.formSearch.slotCode = ''; // 路径
      this.formSearch.mapName = ''; // 路径
      this.formSearch.timer = ''; // 发布时间
      this.formSearch.workClass = ''; // 模式
      this.getSheetDayInfo();
    },
  },
};
</script>

<style lang="scss">
.device-detail-sheet-daily-sbr {
  background-color: #e4ebf2;
  padding-top: 16px;
  .title {
    padding-left: 10px;
    background: rgba(53, 184, 224, 0.15);
    border-radius: 2px;
    font-size: 12px;
    line-height: 32px;
    color: #6c757d;
    .icon {
      color: RGBA(13, 154, 224, 1);
      margin-right: 10px;
    }
  }
  .usage {
    background-color: #fff;
    border-radius: 2px;
    .usage-introduction {
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        height: 17px;
        font-size: 12px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 17px;
      }
      .introduction-right {
        margin-top: 24px;
        margin-bottom: 16px;
        display: flex;
        justify-content: center;
        div {
          i {
            display: inline-block;
            width: 12px;
            height: 12px;
            margin-right: 8px;
            line-height: 28px;
          }
          // height: 17px;
          // font-size: 12px;
          // color: rgba(51, 51, 51, 1);
          // line-height: 17px;
          // display: inline-block;
          margin-right: 20px;
          height: 28px;
          font-size: 12px;
          color: rgba(51, 51, 51, 1);
          line-height: 28px;
          display: flex;
          align-items: center;
        }
        div:last-child {
          margin-left: 0;
        }
        .charge {
          i {
            background-color: #FFAD00;
          }
        }
        .manual {
          i {
            background-color: #8ECC4D;
          }
        }
        .auto {
          i {
             background-color: #008D6A;
          }
        }
        .train {
          i {
             background-color: #393F4C;
          }
        }
        .boot{
          i {
            background-color: #00A0D9;
          }
        }

      }
    }
    .usage-hours {
      display: flex;
      .usage-icon {
        align-self: center;
        flex: 0 0 78px;
        width: 7px;
        i {
          display: inline-block;
          margin-right: 38px;
          width: 40px;
          height: 40px;
          img {
            width: 100%;
            height: 100%;
          }
          &:last-of-type {
            margin-top: 72px;
          }
        }
      }
      // margin-top: 12px;
      .log {
        flex: 1;
        padding-right: 12px;
        .line {
          width: 100%;
          margin-top: 16px;
          .bg {
            background-color: #f5f5f5;
            height: 12px;
            width: 100%;
            position: relative;
            .charge {
              background-color: #FFAD00;
              z-index: 10;
            }
            .manual {
              background-color: #8ECC4D;
              border-bottom: 1px solid #F5F5F5;
              bottom: 2px;
              z-index: 10;
            }
            .auto {
              background-color: #008D6A;
              border-bottom: 1px solid #F5F5F5;
              bottom: 2px;
              z-index: 10;
            }
            .train {
              background-color: #393F4C;
              border-bottom: 1px solid #F5F5F5;
              bottom: 2px;
              z-index: 10;
            }
            .boot {
              background-color: #00A0D9;
              z-index: 1;
            }
          }
          .lable-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 20px;
            margin: 0 -10px; //超出边边
            i {
              width: 20px;
              height: 20px;
              font-size: 12px;
              color: rgba(108, 117, 125, 1);
              line-height: 20px;
              text-align: center;
              position: relative;
              &:before {
                height: 3px;
                width: 1px;
                background-color: rgba(0, 0, 0, 0.1);
                // text-align: right;
                content: '';
                display: block;
                position: absolute;
                top: 0px;
                left: 50%;
              }
              &:last-of-type:before {
                position: absolute;
                top: 0;
                right: 0;
              }
            }
          }
          &:nth-child(1) {
            margin-top: 8px;
          }
          &:nth-child(3) {
            margin-top: 32px;
          }
        }
      }
    }
  }
  .sheet-info {
    margin-top: 16px;
    .box {
      padding: 0 16px;
      display: flex;
      li.item {
        border-right: 1px solid #e9ebec;
        margin-left: 32px;
        &:first-child {
          margin: 0;
        }
        .mode {
          height: 28px;
          font-size: 15px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
          margin-bottom: 12px;
        }
        ul {
          display: flex;
          .param {
            padding-right: 32px;
            h2 {
              height: 17px;
              font-size: 12px;
              color: rgba(152, 166, 173, 1);
              line-height: 17px;
              margin-bottom: 5px;
              white-space: normal;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            p {
              height: 26px;
              font-size: 22px;
              font-weight: bold;
              color: rgba(57, 70, 104, 1);
              line-height: 26px;
            }
          }
        }

        &:last-of-type {
          border: none;
        }
      }
    }
    .time {
      color: #0d9ae0;
    }
    .box-bottom {
      margin-top: 16px;
      text-align: right;
      height: 17px;
      font-size: 12px;
      color: #6c757d;
      line-height: 17px;
    }
  }
  .card {
    border-radius: 2px;
    background-color: #fff;
    margin-top: 16px;
    padding: 20px 24px;
    .titel {
      height: 28px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 28px;
      margin-bottom: 20px;
    }
    ul {
      li {
        height: 70px;
        background: #ffffff;
        padding: 13px 17px 13px 16px;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        .icon {
          width: 44px;
          height: 44px;
          margin-right: 24px;
          img {
            display: inline-block;
            width: 100%;
          }
        }
        .info {
          margin-right: 44px;
          p {
            height: 17px;
            font-size: 12px;
            color: rgba(73, 80, 87, 1);
            line-height: 17px;
          }
          span {
            height: 25px;
            font-size: 13px;

            font-weight: bold;
            color: rgba(73, 80, 87, 1);
            line-height: 25px;
          }
        }
        .inner {
          flex: 1;

          .param {
            display: flex;
            overflow-x: auto;
            .name {
              padding: 0 24px 0 20px;
              border-right: 1px solid #e9ebec;
              flex-shrink: 0;
              p {
                height: 17px;
                font-size: 12px;
                color: rgba(152, 166, 173, 1);
                line-height: 17px;
              }
              span {
                height: 25px;
                font-size: 13px;

                font-weight: bold;
                color: rgba(73, 80, 87, 1);
                line-height: 25px;
              }
              &:last-of-type {
                border: none !important;
              }
            }
          }
        }
        .card-title {
          height: 21px;
          font-size: 12px;

          font-weight: bold;
          color: rgba(73, 80, 87, 1);
          line-height: 21px;
          .user {
            height: 21px;
            font-size: 12px;
            color: rgba(57, 70, 104, 1);
            line-height: 21px;
          }
          .right {
            float: right;
            height: 17px;
            font-size: 12px;
            color: rgba(13, 154, 224, 1);
            line-height: 17px;
          }
        }
        .card-tips {
          height: 17px;
          font-size: 12px;
          color: rgba(108, 117, 125, 1);
          line-height: 17px;
          .right {
            float: right;
            height: 17px;
            font-size: 12px;
            color: rgba(108, 117, 125, 1);
            line-height: 17px;
          }
        }
        &:hover {
          background: #f9f9fd;
        }
        .more {
          color: #0d9ae0;
          font-size: 12px;
          color: rgba(13, 154, 224, 1);
          line-height: 22px;
          margin-left: auto;
          cursor: pointer;
          i {
            color: #0d9ae0;
            font-size: 12px;
          }
        }
        &:nth-child(odd) {
          background-color: #f9f9fd;
        }
      }
    }
  }
  .detail-list {
    margin-top: 16px;
    // padding: 0 24px;
    padding: 0 !important;
  }
  .path {
    // margin-top: 16px;
    background-color: #fff;
    padding: 24px;
    .search-hd {
      padding-top: 0;
      padding-bottom: 24px;
      overflow: hidden;
    }
    .head {
      margin-bottom: 24px;
      display: flex;
      justify-content: space-between;
      p {
        height: 28px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 28px;
      }
    }
  }
}
</style>
